import type { TableSettingsState } from '@/helpers/cookieStorage/userSettings/tableSettings/shared'

export const COLUMN_IDS = {
  Network: 'network',
  Vault: 'vault',
  Assets: 'assets',
  NetApy: 'netApy',
  RiskCurator: 'riskCurator',
  CollateralExposures: 'collateralExposures',
  PositionManager: 'positionManager',
  RealizedEarnings: 'realizedEarnings'
}

export const EARN_POSITIONS_DEFAULT_TABLE_SETTINGS: TableSettingsState = {
  columnVisibility: {},
  sorting: [
    {
      id: COLUMN_IDS.Assets,
      desc: true
    }
  ],
  columnFilters: [],
  columnOrder: [],
  version: 2
}
export const EARN_POSITIONS_STORAGE_KEY = 'earnPositionsTable'
